import { ROUTE } from '../constant/route.constant';

export type RouteErrorCode =
  | typeof ROUTE.ERROR['BAD_REQUEST']
  | typeof ROUTE.ERROR['FORBIDDEN']
  | typeof ROUTE.ERROR['NOT_FOUND']
  | typeof ROUTE.ERROR['NOT_ALLOWED']
  | typeof ROUTE.ERROR['NOT_ACCEPTABLE']
  | typeof ROUTE.ERROR['OFFER_EXPIRED'];

export const RouteErrorCode: Record<RouteErrorCode, RouteErrorCode> = {
  '400': ROUTE.ERROR['BAD_REQUEST'],
  '403': ROUTE.ERROR['FORBIDDEN'],
  '404': ROUTE.ERROR['NOT_FOUND'],
  '405': ROUTE.ERROR['NOT_ALLOWED'],
  '406': ROUTE.ERROR['NOT_ACCEPTABLE'],
  'offer-expired': ROUTE.ERROR['OFFER_EXPIRED'],
};
